import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CancelTokenModule } from '../../components/cancel-token/cancel-token.module';
import { MaterialModule } from '../../modules/material/material.module';
import { DynamicTableModule } from '../dynamic-table/dynamic-table.module';
import { EmptyModule } from '../empty/empty.module';
import { PageHeaderModule } from '../page-header/page-header.module';
import { PageTemplateComponent } from './page-template.component';

@NgModule({
  declarations: [PageTemplateComponent],
  imports: [
    CommonModule,
    MaterialModule,
    PageHeaderModule,
    DynamicTableModule,
    EmptyModule,
    CancelTokenModule,
  ],
  exports: [PageTemplateComponent],
})

export class PageTemplateModule {}
